import { SvgIcon, Typography, useTheme } from "@mui/material";
import React, { PropsWithChildren } from "react";
import { icons } from "../utils/icons";

type SearchFieldLabelProps = {
    className?: string;
    noMargin?: boolean;
    smallMargin?: boolean;
    name?: string;
};

// budget
// filter
// sunset
// nature

const getIcon = (name: string) => {
    const icon = name ? icons[name] : null;
    return icon;
};

export const SearchFieldLabel: React.FC<
    PropsWithChildren<SearchFieldLabelProps>
> = ({ children, className, noMargin, smallMargin, name }) => {
    const theme = useTheme();
    const icon = getIcon(name);
    return (
        <div
            className={`flex items-center gap-4 ${
                !noMargin && smallMargin
                    ? "mb-[0px] sm:mb-[6px]"
                    : "mb-[6px] sm:mb-[12px]"
            }`}
        >
            {icon && (
                <SvgIcon
                    component={icon[0]}
                    inheritViewBox
                    style={{
                        width: 20,
                        height: 20,
                        stroke: icon[1]
                            ? theme.palette.primary.main
                            : undefined,
                        fill: icon[1] ? "none" : undefined
                    }}
                    color="primary"
                />
            )}
            <Typography
                color={"shBlack"}
                className={className}
                sx={{
                    fontSize: 13,
                    letterSpacing: 0.4,
                    lineHeight: "20px",
                    fontWeight: 700
                    //marginBottom: noMargin ? undefined : "8px"
                }}
            >
                {children}
            </Typography>
        </div>
    );
};
